<script>
  import { Switch } from 'element-ui'
  export default {
    name:'ElSwitch',
    extends:Switch
  }
</script>
